export const ERROR_MESSAGES = {
  templatedInputMusContainsStop:
    'Message must include the word "STOP" to allow users to opt out',
  templatedInputVariableMustBeValid:
    'Remove incorrect variables. Correctly added variables have a green background. To add variables, type @ or { and choose from the list'
};
